import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { CustomCookieService } from '../services/custom-cookie.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: LoaderService,
    private customCookieService: CustomCookieService,
    ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loaderService.show()
    const mdn = request.headers.get('mdn');
    if (mdn) {
      this.customCookieService.saveData('ui-selectedMdn', mdn, '/', true);
    }
    return next.handle(request).pipe(finalize(() => this.loaderService.hide()))
  }
}
